<template lang="pug">
  // TABLE that displays USERs Information
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', v-else)
</template>

<script>
import { db } from '@/firebase'

const usersRef = db.ref('users')

export default {
  name: 'user-table',
  data() {
    return {
      usersCount: 0,
      loading: true,
      tableItems: [],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center',
        },
        user: {
          label: 'Customer',
        },
        fbId: {
          label: 'Facebook Messenger ID',
        },
        phoneId: {
          label: 'Phone Number',
        },
        timezone: {
          label: 'GMT',
        },
        /* influence: {
          label: 'Social Influence',
          class: 'text-center'
        }, */
        intent: {
          label: 'Language',
        },
        actions: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '9em',
          },
        },
      },
    }
  },
  mounted: function() {
    usersRef.once('value').then((snapshot) => {
      this.usersCount = snapshot.numChildren()
    })
    var msgs
    usersRef.limitToLast(3).on('value', (snapshot) => {
      msgs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          var msg = {
            avatar: { url: val.profilePic, tooltip: key },
            userId: key,
            user: { name: (val.firstName && val.lastName) ? (val.firstName + ' ' + val.lastName) : val.shortID, new: val.new, registered: val.registered, gender: val.gender },
            actions: { id: key, paused: false },
            // agent: { url: 'static/img/avatars/1.jpg', status: 'success', tooltip: 'Yiorgos Avraamu' },
            // messageId: key,
            fbId: val.fb,
            intent: 'English (UK)',
            // influence: val.influence,
            phoneId: val.phoneNumber,
            timezone: val.timezone,
          }
          msgs.unshift(msg)
        })
      console.log(msgs)
      this.loading = false
      this.tableItems = msgs
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/userTable.vue?50ec6d6e